module.exports = __webpack_public_path__ + "img/succinct.9a19c34c.png";